import { IChangeQuestion, IQuestionChanges } from '@/contracts/modules/education/use-case/IChangeQuestion'
import { ChangeQuestionRoute } from '@/modules/education/v1/api/v1/questions/ChangeQuestion/ChangeQuestionRoute'
import { ChangeQuestionParams } from '@/modules/education/v1/api/v1/questions/Dto/ChangeQuestionParams'

export class ChangeQuestion implements IChangeQuestion {
  async exec(question: string, changes: IQuestionChanges): Promise<string> {
    const response = await new ChangeQuestionRoute(question).exec(new ChangeQuestionParams(changes))
    if (!response.isSuccess()) {
      throw new Error(response.getError())
    }
    return response.getData().uuid
  }
}
